import { Copy, ArrowUpRight } from "lucide-react";
import { toast } from "sonner";
import { Reveal } from "./SectionHead";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const Contact = ({ index, site }) => {
  const EMAIL = site?.email ?? "";
  const socials = (site?.socials ?? []).filter((s) => s.url);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      toast.success("EMAIL COPIED TO CLIPBOARD");
    } catch {
      toast.error("Copy failed — select the address manually");
    }
  };

  return (
    <section id="contact" data-testid="contact-section" className="relative px-5 sm:px-10 lg:px-16 py-16 md:py-24">
      <Reveal>
        <div className="clip-corner bg-[#F5A524] text-black p-8 sm:p-14 lg:p-20 relative overflow-hidden grain">
          <p className="font-mono text-xs tracking-[0.35em] mb-6">// {index} — CONTACT</p>
          <h2 className="font-display font-black uppercase text-5xl sm:text-7xl lg:text-[8.5rem] leading-[0.82] tracking-tight max-w-5xl">
            {site?.contact_heading}
          </h2>
          <div className="mt-8 md:mt-12 flex flex-col lg:flex-row lg:items-end justify-between gap-8 lg:gap-10">
            <div>
              <p className="font-mono text-xs tracking-[0.25em] mb-3">COMMISSIONS · COLLABS · ZINES</p>
              {EMAIL && <div className="flex flex-wrap items-center gap-3">
                <a data-testid="contact-email-link" href={`mailto:${EMAIL}`} className="font-display font-bold text-2xl sm:text-4xl underline decoration-2 underline-offset-8 hover:decoration-[6px] break-all">{EMAIL}</a>
                <button data-testid="contact-copy-email-btn" onClick={copy} aria-label="Copy email"
                  className="bg-black text-[#F5A524] p-3 hover:bg-[#12131A] hover:scale-105 active:scale-95 transition-transform">
                  <Copy size={18} />
                </button>
              </div>}
            </div>
            {socials.length > 0 && <div className={`grid ${socials.length > 1 ? "grid-cols-2" : "grid-cols-1"} gap-px bg-black border border-black min-w-[240px]`}>
              {socials.map(({ label, url }) => (
                <a key={label} data-testid={`social-link-${slug(label)}`} href={url} target="_blank" rel="noreferrer"
                  className="group bg-[#F5A524] hover:bg-black hover:text-[#F5A524] px-5 py-4 font-mono text-xs tracking-[0.2em] uppercase flex items-center justify-between gap-3 transition-colors">
                  {label} <ArrowUpRight size={14} className="transition-transform group-hover:rotate-45" />
                </a>
              ))}
            </div>}
          </div>
        </div>
      </Reveal>
    </section>
  );
};
